import React, { useEffect, useState } from "react";
import { Collapse } from "antd";
import "../../styles/Faq.css";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchQuestions } from "../../redux/faqSlice"; // Import the async action
import { useTranslation } from "react-i18next";

// const items = [
//   {
//     key: "1",
//     label: "This is panel header 1",
//     label: "How to book a cleaning service from Samoolah?",
//     children: (
//       <h4 className="text-lg max-lg:text-base text-center mt-5 pl-6 max-lg:pl-3 pr-10 max-lg:pr-3">
//         {text}
//       </h4>
//     ),
//   },
//   {
//     key: "2",
//     label: "How to book a cleaning service from Samoolah?",
//     children: (
//       <h4 className="text-lg max-lg:text-base text-center mt-5 pl-6 pr-10 max-lg:pr-6">
//         {text}
//       </h4>
//     ),
//   },
//   {
//     key: "3",
//     label: "How to book a cleaning service from Samoolah?",
//     children: (
//       <h4 className="text-lg max-lg:text-base text-center mt-5 pl-6 pr-10 max-lg:pr-6">
//         {text}{" "}
//       </h4>
//     ),
//   },
//   {
//     key: "4",
//     label: "How to book a cleaning service from Samoolah?",
//     children: (
//       <h4 className="text-lg max-lg:text-base text-center mt-5 pl-6 pr-10 max-lg:pr-6">
//         {text}
//       </h4>
//     ),
//   },
// ];

const FAQ = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const dispatch = useDispatch();
  const { questions, status, error } = useSelector((state) => state.questions);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchQuestions());
    }
  }, [status, dispatch]);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const customExpandIcon = ({ isActive }) =>
    isActive ? (
      <MinusOutlined className="plus-icon mt-4" />
    ) : (
      <PlusOutlined className="plus-icon mt-4" />
    );

  if (status === "loading") return <p>Loading...</p>;
  if (status === "failed") return <p>Error: {error}</p>;

  return (
    <div className="faq mb-6 max-lg:mx-5">
      <p className="text-xl max-lg:text-lg text-center text-[#737E91]">{t("Frequently Asked")}</p>
      <h2 className="text-4xl max-lg:text-xl text-center mb-10 text-[#14294F] font-semibold">
        {t("Got Questions? Check Our FAQ")}
      </h2>
      <div className="flex justify-center mx-auto">
        <Collapse
          defaultActiveKey={["1"]}
          inlineCollapsed={collapsed}
          expandIcon={customExpandIcon}
          expandIconPosition="right"
          bordered={false}
          style={{ fontWeight: "400", fontFamily: "Comfortaa" }}
          className="text-2xl faq-text text-blue-600  max-lg:text-xl w-3/4 max-lg:w-full"
        >
          {questions.map((question, index) => (
            <Collapse.Panel
              header={
                language === "en"
                  ? question.desc_en == null
                    ? question.desc.replace(/<\/?[^>]+(>|$)/g, "")
                    : question.desc_en.replace(/<\/?[^>]+(>|$)/g, "")
                  : question.desc.replace(/<\/?[^>]+(>|$)/g, "")
              }
              key={index + 1}
            >
              <h4 className="text-lg max-lg:text-base text-center mt-5 pl-6 max-lg:pl-3 pr-10 max-lg:pr-3">
                {language === "en"
                  ? question.answer_en || question.answer
                  : question.answer}
              </h4>
            </Collapse.Panel>
          ))}
        </Collapse>
      </div>
      {/* <Link
        to="/"
        className="text-[#FE9B71] rounded-full my-4 border-4 border-[#FE9B71] w-[250px] h-[65px] text-2xl flex items-center justify-center font-semibold mx-auto"
      >
        {t("Explore All")}
      </Link> */}
    </div>
  );
};

export default FAQ;
